import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    loadingContainer: {
        justifyContent: "center",
        alignItems: "center"
    },
    container: {
        justifyContent: "center",
        alignItems: "center",
        flex: 1
    }
});

export default stylesheet;
